<template>
    <div class="the-detail-inner site-detail-inner-updatesites">
        <updatesite-section
            v-bind:show-full-list-link="false"
            v-bind:show-back-link="true"
            v-bind:show-pagination="true"
            v-bind:limit="20"
            v-on:close-detail="close"
        >
        </updatesite-section>
    </div>
</template>

<script>

import { mapMutations } from 'vuex'

import UpdatesiteSection from './UpdatesiteSection'

export default {

  name: 'SiteDetailUpdatesites',

  components: {
    UpdatesiteSection
  },

  methods: {

    ...mapMutations('site', [
      'closeSiteDetailPageUpdatesites'
    ]),

    close () {
      this.closeSiteDetailPageUpdatesites()
    }
  }
}
</script>
